module.exports = __webpack_public_path__ + "assets/8e54c0efe35726e7e8a5a6ee0fc8d38b.mp4";